import axios from "axios";

export default {
  methods: {
    /**
         * Retorna todos os analistas das unimeds
         * @return {Promise<[
            {
              "id": 0,
              "nome": "string",
              "nomeComPapel": "string"
            }
          ]>}
         */
    getAnalistas() {
      return axios.get(
        this.CriarUrl({
          resource: `adm/unimeds/observacoes/usuarios`
        })
      );
    }
  }
};
